'use strict';
import {reduxList as peopleList} from '../redux/peopleList';
import {reduxList as peopleSelectorList} from '../redux/peopleSelectorList';
import {reactReduxModal as peopleSelectorModal} from '../redux/peopleSelectorModal';

export const epics = [
  ...peopleList.epics.epics,
  ...peopleSelectorList.epics.epics,
  ...peopleSelectorModal.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/personnel/epics/index.js